import { render, staticRenderFns } from "./FailureDescriptionCmp.vue?vue&type=template&id=22ccdbaa"
import script from "./FailureDescriptionCmp.vue?vue&type=script&lang=js"
export * from "./FailureDescriptionCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22ccdbaa')) {
      api.createRecord('22ccdbaa', component.options)
    } else {
      api.reload('22ccdbaa', component.options)
    }
    module.hot.accept("./FailureDescriptionCmp.vue?vue&type=template&id=22ccdbaa", function () {
      api.rerender('22ccdbaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/FileUploadManagement/cmp/FailureDescriptionCmp.vue"
export default component.exports